import httpClient from './httpClient'

export const httpClientFetcher = <T = unknown>(url: string) =>
  httpClient.get<T>(url).then((res) => res.data)
